// Import libraries
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { MainLayoutRoute } from './layouts/MainLayout';

import { FullScreenRoute } from './layouts/FullScreenLayout';
import { PageLayoutRoute } from './layouts/PageLayout';
import { MultiViewRoute } from './layouts/MultiViewLayout';
import { GamesFullViewRoute } from './layouts/GamesFullViewLayout';
import UserRedirect from './components/base/UserRedirect';
import BusinessRules from './components/base/businessRules/BusinessRules';

//Import site routs 
import { RoutePath } from './constants/SitePaths';

//Account 
import { connect } from 'react-redux';
import { resetPopupsVisibility, getSettings } from './actions/settings/SettingsAction';
import 'react-spring-bottom-sheet/dist/style.css'
import "rc-slider/assets/index.css";
import './assets/styles/customize.css'

import { BuilderInteractions } from './components/BuilderInteractions'
import PopupListener from './components/PopupListener'
import { Affiliate } from './services/affiliate/Affiliate'

import { PopupRoute } from './layouts/PopupLayout';
import { AuthRoute } from './layouts/AuthLayout';
import EmptyPlaceholder from './components/placeholders/EmptyPlaceHolder';
import NotificationService from './components/base/notifications/NotificationService';
import Cookies from './components/base/Cookies';
import CookiesService from './services/cookies/CookiesService'
import { LanguageService } from './services/LanguageService';
import config, { template } from './constants/Configs';
import { Constants } from './constants/Constants';
import RemoteLocalStorage from './components/RemoteLocalStorage';
import ErrorBoundary from "./ErrorBoundary";
import OnSettingLoadedComponent from './components/base/OnSettingLoadedComponent';
import PopupEnum from './components/base/PopupEnum';
import Utils from './services/Utils';
import { Browser } from './services/helpers/Browser';
import { Auth } from './services/Auth';

import SiteEventHandler from './components/base/siteEvents/SiteEventHandler';
import NotificationContainer from './components/base/NotificationContainer';
import UnverifiedUserReminder from './components/myProfile/responsibleGaming/UnverifiedUserReminder';
import RestrictionType from './constants/Enums/RestrictionEnum';

const MobileAccountBar = React.lazy(() => import('./components/base/popups/MobileAccountBar'));
const RequestCallbackPopup = React.lazy(() => import('./components/base/popups/RequestCallbackPopup'));
const RequestCashbackPopup = React.lazy(() => import('./components/base/popups/RequestCashbackPopup'));
const PaydromPopup = React.lazy(() => import('./components/base/popups/PaydromPopup'));
const CupisOTPPopup = React.lazy(() => import('./components/base/popups/CupisOTPPopup'));
const RealityCheckReminder = React.lazy(() => import('./components/myProfile/responsibleGaming/realityCheck/RealityCheckReminder'));
const CustomPopup = React.lazy(() => import('./components/base/popups/CustomPopup'));
const HtmlHeadTags = React.lazy(() => import('./components/base/HtmlHeadTags'));
// const SingleTournament = React.lazy(() => import('./routes/tournaments/SingleTournament'));
const PromotionDetails = React.lazy(() => import('./routes/promotions/PromotionDetails'));
// const Tournaments = React.lazy(() => import('./routes/tournaments/Tournaments'));
const RgsTournaments = React.lazy(() => import('./routes/tournaments/rgs-tournaments/RgsTournaments'));
const Gamification = React.lazy(() => import('./routes/gamification/Gamification'));
const PromotionsContainer = React.lazy(() => import('./routes/promotions/PromotionsContainer'));
const CalendarContainer = React.lazy(() => import('./routes/calendar/CalendarContainer'));
const ComplientForm = React.lazy(() => import('./routes/complaints/ComplientForm'));
const ComplaintsHistory = React.lazy(() => import('./routes/complaints/ComplaintsHistory'));
const Registration = React.lazy(() => import('./routes/registration/Registration'));
const Metra = React.lazy(() => import('./routes/Metra'));

const LoginPage = React.lazy(() => import('./routes/loginPage/LoginPage'));
const Popup = React.lazy(() => import('./components/base/popups/Popup'));
const RegistrationPopup = React.lazy(() => import('./components/base/popups/RegistrationPopup'));
const ForgotPopup = React.lazy(() => import('./components/base/popups/ForgotPopup'));
const LoginPopup = React.lazy(() => import('./components/base/popups/LoginPopup'));
const JoinPopup = React.lazy(() => import('./components/base/popups/JoinPopup'));
const ChangePasswordPopup = React.lazy(() => import('./components/base/popups/ChangePasswordPopup'));

const ProfilePopup = React.lazy(() => import('./components/base/popups/ProfilePopup'));
const PromotionsPopup = React.lazy(() => import('./components/base/popups/PromotionsPopup'));
const MultiView = React.lazy(() => import("./components/casino/MultiView"));
const SingleView = React.lazy(() => import("./components/casino/SingleView"));
const FullScreenView = React.lazy(() => import("./components/casino/FullScreenView"));


const Home = React.lazy(() => import('./routes/Home'));
const Sport = React.lazy(() => import('./routes/Sport'));
const Esport = React.lazy(() => import('./routes/Esport'));
const Livetv = React.lazy(() => import('./routes/Livetv'));
const Game = React.lazy(() => import('./routes/Game'));
const NotFound = React.lazy(() => import('./routes/NotFound'));
const GameLaunch = React.lazy(() => import('./routes/games/GameLaunch'));
const TvGames = React.lazy(() => import('./routes/games/TvGames'));
const SelfAssessmentForm = React.lazy(() => import('./components/base/selfAssessment/selfAssessmentForm/SelfAssessmentForm'));

/** For Lobby Home and Lobby Pages */
const Lobby = React.lazy(() => import('./routes/Lobby'));

const Betradar = React.lazy(() => import('./routes/games/Betradar'));
const FastGames = React.lazy(() => import('./routes/games/FastGames'));
const Rules = React.lazy(() => import('./routes/Rules'));
const Regulations = React.lazy(() => import('./routes/Regulations'));
const Maintenance = React.lazy(() => import('./routes/Maintenance'));
const Restricted = React.lazy(() => import('./routes/restricted/Restricted'));
const Payment = React.lazy(() => import('./routes/payments/Payment'));
const PaymentNative = React.lazy(() => import('./routes/payments/PaymentNative'));
const SeoContent = React.lazy(() => import('./components/base/SeoContent'));
const PaymentSubmit = React.lazy(() => import('./routes/payments/PaymentSubmit'));
const PaymentSubmitCurrencyConvertion = React.lazy(() => import('./routes/payments/PaymentSubmitCurrencyConvertion'));

const AgentLogin = React.lazy(() => import('./routes/auth/AgentLogin'));
const PasswordChange = React.lazy(() => import('./routes/auth/PasswordChange'));
const CupisFeed = React.lazy(() => import('./routes/CupisFeed'));
const PromotionPreview = React.lazy(() => import('./routes/promotions/PromotionPreview'));
const Pages = React.lazy(() => import('./routes/Pages'));
const Widget = React.lazy(() => import('./routes/widget-editor/Widget'));
const PromoTool = React.lazy(() => import('./routes/gamification/PromoTool'));
const CampaignThunderbite = React.lazy(() => import('./routes/gamification/CampaignThunderbite'));
const ExchangeCenter = React.lazy(() => import('./routes/gamification/ExchangeCenter'));
const JoinBonusCampaign = React.lazy(() => import('./routes/JoinBonusCampaign'));
const ResponsibleGamingNotifications = React.lazy(() => import('./components/myProfile/responsibleGaming/ResponsibleGamingNotifications'));
const SetupLimits = React.lazy(() => import('./components/myProfile/responsibleGaming/SetupLimits'));
const LoginVerification = React.lazy(() => import('./components/login/LoginVerification'));

const pageAliases = {
  Homepage: '/main',
  Casino: '/casino',
  CasinoAlternative: '/playin',
  LiveCasino: '/livecasino',
  LiveCasinoAlternative: '/liveplayin',
  CasinoLobby: '/casino-lobby',
  CasinoLobbyAlternative: '/casino-playin',
  TvGamesLobby: '/tvgames-lobby',
  VirtualSportLobby: '/virtualsport-lobby',
  FastGamesLobby: '/fastgames-lobby',
  Promotions: '/promotions',
  Calendar: '/calendar',
  // Tournaments: '/game-tournaments',
  RgsTournaments: '/tournaments',
  Gamification: '/gamification',
  // SingleTournament: '/single-tournament',
  Games: '/games/',
  Esport: '/esport',
  Livetv: '/livetv',
  Sport: '/sport',
  TvGames: '/tv-games',
  FastGames: '/fast-games',
  Regulations: '/regulations',
  Betradar: '/betradar',
  Pages: '/pages/',
  PromoTool: '/promo/',
  CasinoLobbyHome: '/casino-home',
  LiveCasinoHome: '/livecasino-home',
  LiveCasinoHomeAlternative: '/liveplayin-home',
  TvGamesLobbyHome: '/tvgames-home',
  VirtualSportLobbyHome: '/virtualsport-home',
  FastGamesLobbyHome: '/fastgames-home',
  Campaign: '/campaign/',
  Thunderbite: '/thunderbite/',
  ExchangeCenter: '/exchange-center/',
};

class App extends React.Component {
  constructor(props) {
    super(props);
    const templateSpeceficCss = import(`./assets/styles/templates/template${template}.css`);
    this.props.dispatch(resetPopupsVisibility());
    this.props.dispatch(getSettings());
    if (window.addEventListener) {
      window.addEventListener("message", BuilderInteractions.listener);
      window.addEventListener('online', this.handleOnline);
      window.addEventListener('offline', this.handleOffline);
    } else {
      window.attachEvent("onmessage", BuilderInteractions.listener);
    }
    Affiliate.registerTags();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isSettingsLoading && !this.props.isSettingsLoading) {
      PopupListener.historyListener(this.props.history, this.props.history.location, 'call');
    }
  }

  handleOnline = () => {
    NotificationService.online({ message: LanguageService.getTranslation('internetOnText'), code: 1 });
  }

  handleOffline = () => {
    NotificationService.network({ message: LanguageService.getTranslation('internetOffText'), code: 0 });
  }

  render() {

    const { isLoggedIn, isSettingsLoading, promotionKey, language, page, backgrounds, plugins,
      forgotUsername, customPopupAlias, popupVisible, projectState, isUnderMaintenance, promptOnLogin, homePageInfo, enableEmailOrMobileVerifyOnLogin, restrictionType } = this.props;

    const isPreview = Utils.isPreviewMode();
    const showUnderMaintenance = !projectState || projectState === 2 || isUnderMaintenance;
    return (
      <ErrorBoundary type="route">
        {restrictionType !== RestrictionType.FullBlock ?
          <Router>
            <UserRedirect />
            {!isPreview && !showUnderMaintenance && <BusinessRules />}
            {!isPreview && !showUnderMaintenance && <SiteEventHandler />}
            <Suspense fallback={<></>}><HtmlHeadTags /></Suspense>
            <div id="body-begin-portal"></div>
            {/* <RemoteLocalStorage /> */}
            {!isSettingsLoading && !isPreview && isLoggedIn && <Suspense fallback={<></>}><RealityCheckReminder /></Suspense>}
            {customPopupAlias && <Suspense fallback={<></>}><CustomPopup alias={customPopupAlias} /></Suspense>}
            {popupVisible === PopupEnum.RequestCallback && <Suspense fallback={<></>}><RequestCallbackPopup /></Suspense>}
            {!config.NEW_PLAT && popupVisible === PopupEnum.RequestCashBack && <Suspense fallback={<></>}><RequestCashbackPopup /></Suspense>}
            <NotificationContainer />
            {!Browser.isMobileApp() && plugins && plugins.cookies && !CookiesService.isCookiesAccapted() && <Cookies />}
            {!isSettingsLoading && projectState && <OnSettingLoadedComponent />}
            {isLoggedIn && !isSettingsLoading && !showUnderMaintenance && Utils.objectContainTrue(promptOnLogin || {}) && <Suspense fallback={<></>}><SetupLimits /></Suspense>}
            {isLoggedIn && !isSettingsLoading && enableEmailOrMobileVerifyOnLogin && <Suspense fallback={<></>}><LoginVerification /></Suspense>}
            {<Suspense fallback={<></>}><ResponsibleGamingNotifications /></Suspense>}
            {<Suspense fallback={<></>}><UnverifiedUserReminder /></Suspense>}
            <Route path="/:lang?">
              {isSettingsLoading || !showUnderMaintenance ?
                // restrictionType === RestrictionType.FullBlock ?
                //   <>
                //   </> :
                <>
                  <Switch>
                    {/* MainLayoutRoute */}
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.SPORT}${RoutePath.POPUP_SUFFIX}`} page={RoutePath.SPORT} alias={pageAliases.Sport} component={Sport} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.SPORT2}${RoutePath.POPUP_SUFFIX}`} page={RoutePath.SPORT} alias={pageAliases.Sport} component={Sport} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.ESPORT}${RoutePath.POPUP_SUFFIX}`} page={RoutePath.ESPORT} alias={pageAliases.Esport} pageBgData={backgrounds} component={Esport} placeholder={EmptyPlaceholder} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.LIVETV}${RoutePath.POPUP_SUFFIX}`} page={RoutePath.LIVETV} alias={pageAliases.Livetv} pageBgData={backgrounds} component={Livetv} placeholder={EmptyPlaceholder} />

                    {/* Live Casino Lobby*/}
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang([a-zA-Z]{1,3})?${RoutePath.LIVECASINO}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.LiveCasino} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.LIVECASINO_ALTERNATIVE}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.LiveCasinoAlternative} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />

                    {/*  Casino Lobby*/}
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang([a-zA-Z]{1,3})?${RoutePath.CASINOLOBBY}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.CasinoLobby} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.CASINOLOBBY_ALTERNATIVE}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.CasinoLobbyAlternative} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />

                    {/* Casino lobby home */}

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.CASINOLOBBYHOME}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.CasinoLobbyHome} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.LIVECASINOHOME}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.LiveCasinoHome} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.TVGAMESLOBBYHOME}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.TvGamesLobbyHome} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.VIRTUALSPORTLOBBYHOME}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.VirtualSportLobbyHome} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.FASTGAMESLOBBYHOME}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.FastGamesLobbyHome} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />


                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang([a-zA-Z]{1,3})?${RoutePath.TVGAMESLOBBY}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.TvGamesLobby} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang([a-zA-Z]{1,3})?${RoutePath.VIRTUALSPORTLOBBY}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.VirtualSportLobby} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang([a-zA-Z]{1,3})?${RoutePath.FASTGAMESLOBBY}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.FastGamesLobby} component={Lobby} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PROMOTIONS}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Promotions} pageBgData={backgrounds} component={PromotionsContainer} key={promotionKey} placeholder={EmptyPlaceholder} />
                    {!this.props.history.location.pathname.includes('promotiondetails') && <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.CALENDAR}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Calendar} pageBgData={backgrounds} component={CalendarContainer} key={promotionKey} placeholder={EmptyPlaceholder} />}

                    {/* <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                    path={`/:lang?${RoutePath.TOURNAMENTS}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Tournaments} pageBgData={backgrounds} component={Tournaments} key={promotionKey} placeholder={EmptyPlaceholder} /> */}
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.RGS_TOURNAMENTS}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.RgsTournaments} pageBgData={backgrounds} component={RgsTournaments} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.GAMIFICATION}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Gamification} pageBgData={backgrounds} component={Gamification} placeholder={EmptyPlaceholder} />

                    {/* <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                    path={`/:lang?${RoutePath.SINGLE_TOURNAMENTS}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Tournaments} pageBgData={backgrounds} component={SingleTournament} key={promotionKey} placeholder={EmptyPlaceholder} /> */}

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PROMOTIONDETAILS}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Promotions} pageBgData={backgrounds} component={PromotionDetails} key={promotionKey} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.CALENDARPROMOTIONDETAILS}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Calendar} pageBgData={backgrounds} component={PromotionDetails} key={promotionKey} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PROMOTION_PREVIEW}${RoutePath.POPUP_SUFFIX}`} component={PromotionsContainer} placeholder={EmptyPlaceholder} />
                    <FullScreenRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.GAME}${RoutePath.POPUP_SUFFIX}`} component={Game} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.GAMELAUNCH}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Games} pageBgData={backgrounds} component={GameLaunch} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.TV_GAMES}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.TvGames} pageBgData={backgrounds} component={TvGames} placeholder={EmptyPlaceholder} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.FAST_GAMES}${RoutePath.POPUP_SUFFIX}`} component={FastGames} alias={pageAliases.FastGames} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.BETRADAR}${RoutePath.POPUP_SUFFIX}`} component={Betradar} alias={pageAliases.Betradar} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={[`/:lang?${RoutePath.DEFAULT}`, `/:lang?${RoutePath.HOMEPAGE}`, `/:lang?${RoutePath.DEFAULT}popup/:popupName/:popupid?/:popupparam?`, `/:lang?${RoutePath.HOMEPAGE}/popup/:popupName/:popupid?/:popupparam?`]} alias={pageAliases.Homepage} pageBgData={backgrounds} component={Home} />
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.RULES}${RoutePath.POPUP_SUFFIX}`} component={Regulations} pageBgData={backgrounds} placeholder={EmptyPlaceholder} />
                    <MainLayoutRoute  isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.GAME_INFO}${RoutePath.POPUP_SUFFIX}`}   alternativePath={`/:lang?${RoutePath.RULES_ALTERNATIVE}${RoutePath.POPUP_SUFFIX}`} alias={Constants.GAME_INFO} 
                      alternativeComponent={isSettingsLoading ? null : Regulations}  
                      component={SeoContent} placeholder={EmptyPlaceholder} />
                    {config.NEW_PLAT ? <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.RULES_ALTERNATIVE}${RoutePath.POPUP_SUFFIX}`} component={Regulations} pageBgData={backgrounds} placeholder={EmptyPlaceholder} /> : null}
                    <PageLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PAGES}${RoutePath.POPUP_SUFFIX}`}
                      alias={pageAliases.Pages}
                      pageBgData={backgrounds}
                      settings={{
                        isSettingsLoading: isSettingsLoading,
                        homePageInfo: homePageInfo,
                        component: Pages,
                        page: page
                      }} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PLAY_GAME_MOBILE}${RoutePath.POPUP_SUFFIX}`} component={SingleView} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.COMPLIENT_FORM}${RoutePath.POPUP_SUFFIX}`} component={ComplientForm} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.COMPLAINTS_HISTORY}${RoutePath.POPUP_SUFFIX}`} component={ComplaintsHistory} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PROMO_TOOL}${RoutePath.POPUP_SUFFIX}`} component={PromoTool} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.THUNDERBITE}${RoutePath.POPUP_SUFFIX}`} component={CampaignThunderbite} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.EXCHANGE_CENTER}${RoutePath.POPUP_SUFFIX}`} component={ExchangeCenter} />

                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.BONUS_CAMPAIGN_JOIN}`} component={JoinBonusCampaign} placeholder={EmptyPlaceholder} />

                    <MultiViewRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PLAY_GAME}${RoutePath.POPUP_SUFFIX}`} component={MultiView} />

                    <GamesFullViewRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PLAY_GAME_FULL}${RoutePath.POPUP_SUFFIX_PARAMS}`} component={FullScreenView} />

                    <MainLayoutRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.CUPIS_FEED}`} component={CupisFeed} placeholder={EmptyPlaceholder} />

                    {/* FullScreenRoute */}
                    <FullScreenRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.REGULATIONS}${RoutePath.POPUP_SUFFIX}`} alias={pageAliases.Regulations} component={Rules} placeholder={EmptyPlaceholder} />

                    <FullScreenRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PAYMENT}`} component={Payment} placeholder={EmptyPlaceholder} />
                    <FullScreenRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.APP_PAYMENT}`} isNative={true} component={PaymentNative} placeholder={EmptyPlaceholder} />

                    <FullScreenRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PAYMENT_SUBMIT}`} component={PaymentSubmit} placeholder={EmptyPlaceholder} />


                    <FullScreenRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.AGENT_LOGIN}`} component={AgentLogin} placeholder={EmptyPlaceholder} />

                    <FullScreenRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PAYMENT_SUBMIT_2}`} component={PaymentSubmitCurrencyConvertion} placeholder={EmptyPlaceholder} />
                    {/* Widget Editor */}
                    <FullScreenRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.WIDGET_EDITOR}`} component={Widget} placeholder={EmptyPlaceholder} />

                    <MainLayoutRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.WIDGET_PREVIEW}`} component={Home} placeholder={EmptyPlaceholder} />
                    {/* <MainLayoutRoute isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.GAME_INFO}`} alias={Constants.GAME_INFO} component={SeoContent} placeholder={EmptyPlaceholder} /> */}

                    {config.NEW_PLAT ? 
                    <AuthRoute isSettingsLoading={isSettingsLoading} language={language}
                        path={`/:lang?${RoutePath.PASSWORD_CHANGE}${RoutePath.POPUP_SUFFIX}`} isPage={true} alias={Constants.GAME_INFO} component={PasswordChange} placeholder={EmptyPlaceholder}/> 
                    : 
                    <>
                      <AuthRoute isSettingsLoading={isSettingsLoading} language={language}
                        path={`/:lang?${RoutePath.REGISTRATION}${RoutePath.POPUP_SUFFIX}`} isPage={true} alias={Constants.GAME_INFO} component={Registration} placeholder={EmptyPlaceholder} />

                      <AuthRoute isSettingsLoading={isSettingsLoading} language={language}
                        path={`/:lang?${RoutePath.LOGIN}${RoutePath.POPUP_SUFFIX}`} isPage={true} alias={Constants.GAME_INFO} component={LoginPage} placeholder={EmptyPlaceholder} />
                      <AuthRoute isSettingsLoading={isSettingsLoading} language={language} isPage={true}
                        path={`/:lang?${RoutePath.JOIN}${RoutePath.POPUP_SUFFIX}`} alias={Constants.GAME_INFO} component={LoginPage} placeholder={EmptyPlaceholder} />
                    </>}
                    
                    {config.NEW_PLAT && <MainLayoutRoute path={`/:lang?${RoutePath.SELF_ASSESSMENT}`} isSettingsLoading={isSettingsLoading} language={language} component={SelfAssessmentForm} placeholder={EmptyPlaceholder} />}
                    <MainLayoutRoute isSettingsLoading={isSettingsLoading} language={language} component={NotFound} placeholder={EmptyPlaceholder} />

                  </Switch>
                  <Switch>
                    <MainLayoutRoute exact isSettingsLoading={isSettingsLoading} language={language}
                      path={`/:lang?${RoutePath.PROMOTION_PREVIEW}`} component={PromotionPreview} />
                  </Switch>
                  <Route path={`/:lang${RoutePath.METRA}`}>
                    <Suspense fallback={<></>}><Metra /></Suspense>
                  </Route>
                  <ErrorBoundary>
                    <Route path={RoutePath.POPUP}>
                      <Suspense fallback={<></>}><Popup /></Suspense>
                    </Route>
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.ACCOUNTMENU_POPUP} component={MobileAccountBar} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.REGISTRATION_POPUP} component={RegistrationPopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.FORGOT_POPUP} component={ForgotPopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.FORGOT_USERNAME} component={ForgotPopup} disabled={!forgotUsername} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.LOGIN_POPUP} component={LoginPopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.JOIN_POPUP} component={JoinPopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.CUPIS_OTP_POPUP} component={CupisOTPPopup} />

                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.CHANGE_POPUP} component={ChangePasswordPopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.PROFILE_POPUPS} component={ProfilePopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.PROMOTIONS_POPUP} component={PromotionsPopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.CUSTOM_POPUP} component={CustomPopup} />
                    <PopupRoute isSettingsLoading={isSettingsLoading} language={language} path={RoutePath.PAYDROM_WALLET_POPUP} component={PaydromPopup} />
                  </ErrorBoundary>
                </> :
                <Switch>
                  <FullScreenRoute component={Maintenance} />
                </Switch>
              }
            </Route>
          </Router> :
          <FullScreenRoute component={Restricted} />
        }
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    demoMode: state.settings.demoMode,
    projectState: state.settings.projectState,
    isUnderMaintenance: state.settings.isUnderMaintenance,
    isSettingsLoading: state.settings.isLoading,
    homePageInfo: state.settings.homePageInfo,
    promotionKey: state.promotions.promotionKey,
    restrictionType: state.settings.restrictionType,
    languages: state.settings.languages,
    language: state.user.language,
    page: state.pages.page,
    backgrounds: state.pages.backgrounds,
    plugins: state.settings.plugins,
    isLoggedIn: state.user.isLoggedIn,
    forgotUsername: state.settings.forgotUsername,
    popupVisible: state.ui.popupVisible,
    popup: state.popup,
    customPopupAlias: state.popup.customPopupAlias,
    promptOnLogin: state.settings.features?.promptOnLogin,
    realityCheckPopupVisibility: state.user.realityCheckPopupVisibility,
    enableEmailOrMobileVerifyOnLogin: state.settings.enableEmailOrMobileVerifyOnLogin
  });
};

const mapDispatchToProps = (dispatch, props) => {
  return ({
    dispatch,
    props
  });
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
